import xhttp from 'src/utils/xhttp'

// 业务对象详情
export function getServiceDetail(webappId, objectId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/objects/${objectId}`)
}

// 刷新详情接口
export function refreshServiceDetail(webappId, objectId) {
    return xhttp.put(`/api/dev/webapp/${webappId}/objects/${objectId}/refresh`)
}
/**
 * 获取分组列表
 * @param {String} objectId
 */
export function getGroupList(objectId) {
    return xhttp.get(`/api/dev/objects/${objectId}/group`)
}

/**
 * 获取单个分组下服务列表
 * @param {Number} page
 * @param {Number} pageSize
 * @param {String} group_id
 */
export function getServiceList(params) {
    const { objectId, ...rest } = params
    return xhttp.get(`/api/dev/objects/${objectId}/group/service`, {
        params: rest
    })
}

/**
 * 新增分组
 * @param {String} objectId
 * @param {String} name
 */
export function createGroup({ objectId, ...rest }) {
    return xhttp.post(`/api/dev/objects/${objectId}/group`, rest)
}

/**
 * 修改分组名
 * @param {String} objectId
 * @param {String} groupId
 * @param {String} name
 */
export function editGroup({ objectId, groupId, ...rest }) {
    return xhttp.put(`/api/dev/objects/${objectId}/group/${groupId}`, rest)
}

/**
 * 删除分组
 * @param {String} folderId
 * @param {String} name
 */
export function deleteGroup({ objectId, groupId }) {
    return xhttp.delete(`/api/dev/objects/${objectId}/group/${groupId}`)
}

/**
 * 添加服务
 * @param {String} objectId
 * @param {String} name
 * @param {String} title
 * @param {String} groupId
 * @param {String} support_compontent
 * @param {String} relativePath
 */
export function addService({ objectId, ...rest }) {
    return xhttp.post(`/api/dev/objects/${objectId}/service`, rest)
}

/**
 * 修改服务
 * @param {String} serviceId
 * @param {String} name
 * @param {String} title
 * @param {String} groupId
 * @param {String} support_compontent
 * @param {String} relativePath
 */
export function editService({ serviceId, ...rest }) {
    return xhttp.put(`/api/dev/objects/service/${serviceId}`, rest)
}

// 删除服务
export function deleteService(serviceId) {
    return xhttp.delete(`/api/dev/objects/service/${serviceId}`)
}

// 获取数据组件列表
export function getDataComponent() {
    return xhttp.get('/api/dev/data-component')
}
